/**
 * Godot 4.6.3's soft shadow of a directional light with a `light_angular_distance`: the angle its
 * blocker search widens by, the box it widens, and the size it lights with
 * (`servers/rendering/renderer_rd/storage_rd/light_storage.cpp:668-703`,
 * `servers/rendering/renderer_scene_cull.cpp:2286-2299`).
 */
import { degToRad } from '../../math/math.js';
/**
 * `softshadow_angle`: the tangent of the angular distance, or zero for none
 * (`light_storage.cpp:676-689`, `:698`).
 */
export function softShadowAngle(angularDistance) {
    return angularDistance > 0 ? Math.tan(degToRad(angularDistance)) : 0;
}
/**
 * Whether this light turns on `sc_use_directional_soft_shadows`, which then holds for every
 * directional light of the render (`scene_forward_clustered.glsl:2310`, `:2617`).
 */
export function drawsDirectionalSoftShadow({ angularDistance, shadowEnabled, shadowBlur, lightsSurfaces, }) {
    return lightsSurfaces && angularDistance > 0 && shadowEnabled && shadowBlur > 0;
}
/** The light's `size`: the cosine offset its angular distance adds to N.L (`light_storage.cpp:670`). */
export function directionalLightSize(angularDistance) {
    return 1 - Math.cos(degToRad(angularDistance));
}
/**
 * How far each side of a split's box widens, so that a caster the blocker search reaches is in the
 * box (`renderer_scene_cull.cpp:2290-2291`). `zRange` is the box's depth from the light's side to the
 * far side of the split's sphere.
 */
export function softShadowExpand(angle, zRange) {
    return angle * zRange;
}
//# sourceMappingURL=directionalSoftShadow.js.map